import { NgModule } from '@angular/core';
import { BaseStateComponent } from '@layout/base-state.component';
import { FilterButtonModule } from './filter-button/filter-button.module';
@NgModule({
    imports: [FilterButtonModule],
    declarations: [BaseStateComponent],
    exports: [BaseStateComponent],
})
export class BaseLayoutModule {}
